var dino = "https://shopfront-cdn.tekoapis.com/static/586024ada7459afb.svg";

export { dino as default };
